module.exports = __webpack_public_path__ + "media/images/home-share-39dc37cf3213334b48508869eb289c71.jpg";